import React from 'react';
import PropTypes from 'prop-types';
import { TreeSelect } from 'antd';
import './DiseaseSelect.css';

// interface Option {
//   value: string | number;
//   label?: React.ReactNode;
//   disabled?: boolean;
//   children?: Option[];
// }

// const options = [
//   {
//     value: 'zhejiang',
//     label: 'Zhejiang',
//     children: [
//       {
//         value: 'Hangzhou',
//         label: 'Hangzhou',
//         isDisabled: true,
//         // disabled: true,
//         children: [
//           {
//             value: 'xihu',
//             label: 'West Lake',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     value: 'jiangsu',
//     label: 'Jiangsu',
//     children: [
//       {
//         value: 'nanjing',
//         label: 'Nanjing',
//         children: [
//           {
//             value: 'zhonghuamen',
//             label: 'Zhong Hua Men',
//           },
//         ],
//       },
//     ],
//   },
// ];

// const treeData = [
//   {
//     title: 'Node1',
//     value: '0-0',
//     disabled: true,
//     children: [
//       {
//         title: 'Child Node1',
//         value: '0-0-1',
//       },
//       {
//         title: 'Child Node2',
//         value: '0-0-2',
//       },
//     ],
//   },
//   {
//     title: 'Node2',
//     value: '0-1',
//   },
// ];

function DiseaseSelect({ data, defaultValue, onChange }) {
  const onDiseaseChange = value => {
    onChange(value);
  };
  // const dropdownRender = menus => {
  //   if (menus) {
  //     console.log(menus);
  //   }
  //   return <div>{menus}</div>;
  // };

  // const displayRender = (labels, selectedOptions) => {
  //   labels.map((label, i) => {
  //     const option = selectedOptions[i];
  //     if (option.isDisabled) return;
  //     if (i === labels.length - 1) {
  //       return <span key={option.value}>{label}</span>;
  //     }
  //     return <span key={option.value}>{label} / </span>;
  //   });
  // };

  // return (
  //   <>
  //     <Cascader
  //       options={options}
  //       onChange={onDiseaseChange}
  //       // dropdownRender={dropdownRender}
  //       // expandTrigger="hover"
  //       // displayRender={displayRender}
  //       placeholder="Please select"
  //       changeOnSelect
  //     />
  //   </>
  // );
  return (
    <>
      <TreeSelect
        style={{ width: '100%' }}
        value={defaultValue ? defaultValue : null}
        dropdownClassName="disease"
        treeData={data}
        placeholder="请选择部位"
        onChange={onDiseaseChange}
      />
    </>
  );
}
DiseaseSelect.propTypes = {
  data: PropTypes.array.isRequired,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
};

DiseaseSelect.defaultProps = {
  data: [],
  defaultValue: '',
};

export default DiseaseSelect;
